import React, { Component } from 'react';
import {connect} from 'react-redux';
import Logger, {LOG_LEVELS} from '../../../utils/logger';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';

const log = new Logger('BULK_REPLACE_NEW_TASK', LOG_LEVELS.DEBUG);

class NewTask extends Component {

    constructor(props) {
        super(props);
        this.state = Object.assign({}, this.state, {
            currentCheckboxValue: false,
            newCheckboxValue: true,
            currentValue: '',
            newValue: '',
            replaceAllNodeValues: false
        });
    }

    toggleReplaceAllNodeValues() {
        this.setState((prev) => {
            if (!prev.replaceAllNodeValues) {
                return {
                    replaceAllNodeValues: true,
                    currentValue: '',
                    currentCheckboxValue: false
                };
            }
            return { replaceAllNodeValues: false };
        });
    }

    toggleCurrentCheckboxAndValue() {        
        this.setState({
            currentCheckboxValue: !this.state.currentCheckboxValue,
            currentValue: this.state.currentCheckboxValue ? '' : this.state.currentValue
        });
    }

    toggleNewCheckboxAndValue() {        
        this.setState({
            newCheckboxValue: !this.state.newCheckboxValue,
            newValue: this.state.newCheckboxValue ? '' : this.state.newValue
        });
    }

    updateNewValue(event) {
        log.debug("updateNewValue(): event: ", event);
        this.setState({newValue: event.target.value});
    }

    updateCurrentValue(event) {
        log.debug("updateCurrentValue(): event: ", event);
        this.setState({currentValue: event.target.value});
    }

    add(event){
        console.log(this.refs.currentValueCheckbox.value);
    }

    resetInput() {
        this.setState({
            currentValue: '',
            newValue: '',
            replaceAllNodeValues: false
        });
    }

    render() {

        log.debug('render: ', this.props);

        return (
            <div>
                <label className="mt10" disabled="disabled"><LanguageStringResolver string="bulkFindReplace_currentValue" /></label>
                <s-row>
                    <s-col span="8">
                        <input
                            type="text"
                            className={this.state.currentCheckboxValue && !this.state.replaceAllNodeValues ? '' : 'inactive'}
                            ref={(input) => { this.currentValueInput = input; }}
                            value={this.state.currentValue}
                            onChange={(e) => this.updateCurrentValue(e)}
                            disabled={!this.state.currentCheckboxValue || this.state.replaceAllNodeValues}
                        />
                    </s-col>
                    <s-col span="1">
                        <input
                            className="ml15 checkbox"
                            type="checkbox"
                            ref="currentValueCheckbox"
                            value={this.state.currentCheckboxValue}
                            checked={this.state.currentCheckboxValue ? 'checked' : ''}
                            onChange={() => this.toggleCurrentCheckboxAndValue()}
                            disabled={this.state.replaceAllNodeValues}
                        />
                        <label className="checkbox absolute"></label>
                    </s-col>
                </s-row>
                <label className="mt10"><LanguageStringResolver string="bulkFindReplace_newValue" /></label>
                <s-row>
                    <s-col span="8">
                        <input type="text"  className={this.state.newCheckboxValue ? '' : 'inactive'} ref={(input) => { this.newValueInput = input; }}  value={this.state.newValue} onChange={(e) => this.updateNewValue(e)} disabled={this.state.newCheckboxValue ? '' : 'disabled'}/>
                    </s-col>
                    <s-col span="1">
                        <input className="ml15 checkbox" type="checkbox" ref="newValueCheckbox" value={this.state.newValueCheckbox} checked={this.state.newCheckboxValue ? "checked" : ""} onChange={(e) => this.toggleNewCheckboxAndValue()} />
                        <label className="checkbox absolute"></label>
                    </s-col>
                </s-row>
                <div className="bulk-replace-all-row">
                    <s-row>
                        <s-col span="8">
                            <div className="bulk-replace-all-inline">
                                <div className="bulk-replace-all-checkbox-wrap">
                                    <input
                                        className="checkbox"
                                        type="checkbox"
                                        checked={this.state.replaceAllNodeValues}
                                        onChange={() => this.toggleReplaceAllNodeValues()}
                                    />
                                    <label className="checkbox absolute"></label>
                                </div>
                                <div className="bulk-replace-all-labels">
                                    <div><LanguageStringResolver string="bulkFindReplace_replaceAllNodeValues" /></div>
                                    <div className="bulk-replace-all-hint"><LanguageStringResolver string="bulkFindReplace_replaceAllNodeValuesHelp" /></div>
                                </div>
                            </div>
                        </s-col>
                        <s-col span="1"></s-col>
                    </s-row>
                </div>
                <s-row className="mt10">
                    <s-col span="9"></s-col>
                    <s-col span="3" className="text-align-right">
                        {this.state.newValue === "" ? (
                            <button className="secondary" disabled><LanguageStringResolver string="bulkFindReplace_add" /></button>
                        ) : (
                            <button className="secondary" onClick={() => {
                                this.props.onAdd({
                                    newValue: this.state.newValue,
                                    currentValue: this.state.replaceAllNodeValues ? '' : this.state.currentValue,
                                    newCheckboxValue: this.state.newCheckboxValue,
                                    currentCheckboxValue: this.state.replaceAllNodeValues ? false : this.state.currentCheckboxValue,
                                    replaceAllNodeValues: this.state.replaceAllNodeValues
                                });
                                this.resetInput();
                            }}><LanguageStringResolver string="bulkFindReplace_add" />
                            </button>
                        )}
                    </s-col>
                </s-row>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const stateProps = {
        languages: state.languages
    };
    return stateProps;
}

function mapDispatchToProps(dispatch) {

    const dispatchProps = {
    };
    return dispatchProps;

}


export default connect(mapStateToProps, mapDispatchToProps)(NewTask);